import { engineConfigs } from './constants';
import { Engine, EngineConfig } from './types';

export const getDefaultReport = (engine: Engine): any => {
    const engineConfig: EngineConfig = engineConfigs.find(
        (config: EngineConfig) => config.id === engine
    );

    return engineConfig.report;
};

export const getEngineLabel = (engine: Engine): string => {
    const engineConfig: EngineConfig = engineConfigs.find(
        (config: EngineConfig) => config.id === engine
    );

    return engineConfig.label;
};
